<template>
  <div>
    <b-icon
      @click="handleDownloadClick"
      :disabled="!columns || !content"
      class="h3 mb-0 download"
      icon="cloud-download"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import xlsx from "json-as-xlsx";
export default {
  props: {
    settingsInput: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: Array,
      default: () => []
    },
    content: {
      type: Array,
      default: () => []
    },
    sheetName: {
      type: String,
      default: "Items"
    },
    fileName: {
      type: String,
      default: "MySpreadsheet"
    },
    fileHasTimeStamp: {
      type: Boolean,
      default: true
    },
    isNative: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    jsonSheets() {
      if (this.columns && this.content) {
        const fullSheets = [];
        const aSheet = {
          sheet: this.sheetName,
          columns: this.columns,
          content: this.content
        };
        fullSheets.push(aSheet);
        return fullSheets;
      }
      return null;
    }
  },
  data() {
    return {
      settings: {
        fileName: "notset", // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false // Display the columns from right-to-left (the default value is false)
      },
      sheets: []
    };
  },
  components: {},
  mixins: [],
  mounted() {},
  methods: {
    handleDownloadClick() {
      //Add Filename
      this.settings.fileName = this.generateFileName();

      if (!this.jsonSheets) {
        console.log("Data is not valid");
      } else {
        xlsx(this.jsonSheets, this.settings, sheet => {
          console.log("Download complete:", sheet);
        });
      }
    },
    addSheet(sheetName, columns, content) {
      const aSheet = {
        sheet: sheetName,
        columns: columns,
        content: content
      };
      this.sheets.push(aSheet);
    },
    convertFieldToColumn(fields) {
      const columns = JSON.parse(JSON.stringify(fields));

      columns.forEach(aColumn => {
        if (aColumn.hasOwnProperty("key")) {
          aColumn.value = aColumn.key;
          delete aColumn["key"];
        }
        if (aColumn.hasOwnProperty("sortable")) {
          delete aColumn["sortable"];
        }
        if (aColumn.hasOwnProperty("formatter")) {
          delete aColumn["formatter"];
        }
        if (aColumn.hasOwnProperty("tdClass")) {
          delete aColumn["tdClass"];
        }
      });

      return columns;
    },
    generateFileName() {
      let fileName = this.fileName;
      if (this.fileHasTimeStamp) {
        const ts = new Date().valueOf();
        fileName = `${fileName}_${ts}`;
      }
      return fileName;
    }
  }
};
</script>

<style lang="scss" scoped>
.download {
  cursor: pointer;
  color: #0a111a;
  &:hover {
    color: #5695e0;
  }
}
</style>
